import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AccordionModule } from 'primeng/accordion';
import { ProgressBarModule } from 'primeng/progressbar';

import { FooterSectionComponent } from './components/footer-section/footer-section.component';
import { HeaderComponent } from './components/header/header.component';
import { GetReadySectionComponent } from './pages/home/components/get-ready-section/get-ready-section.component';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './pages/home/home.component';
import { HeroSectionComponent } from './pages/home/components/hero-section/hero-section.component';
import { AtsResumeSectionComponent } from './pages/home/components/ats-resume-section/ats-resume-section.component';
import { AutomateSectionComponent } from './pages/home/components/automate-section/automate-section.component';
import { JobSeekersSectionComponent } from './pages/home/components/job-seekers-section/job-seekers-section.component';
import { OptimizeLinkedinSectionComponent } from './pages/home/components/optimize-linkedin-section/optimize-linkedin-section.component';
import { ResumeBuilderSectionComponent } from './pages/home/components/resume-builder-section/resume-builder-section.component';
import { ServicesSectionComponent } from './pages/home/components/services-section/services-section.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { ForgetPasswordComponent } from './pages/auth/login/components/forget-password/forget-password.component';
import { OtpCodeComponent } from './pages/auth/login/components/otp-code/otp-code.component';
import { ResetPasswordComponent } from './pages/auth/login/components/reset-password/reset-password.component';
import { SignUpComponent } from './pages/auth/sign-up/sign-up.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScanCvComponent } from './pages/scan-cv/scan-cv.component';
import { ScanLinkedinComponent } from './pages/scan-linkedin/scan-linkedin.component';
import { ScanLinkedinResultComponent } from './pages/scan-linkedin-result/scan-linkedin-result.component';
import { ScanResultComponent } from './pages/scan-result/scan-result.component';
import { ResumeBuilderStepsSectionComponent } from './pages/home/components/resume-builder-steps-section/resume-builder-steps-section.component';
import { CardComponent } from './components/card/card.component';
import { OAuthModule } from 'angular-oauth2-oidc';
import { CarouselModule } from 'primeng/carousel';
import { AnimateOnScrollModule } from 'primeng/animateonscroll';

import { TokenInterceptor } from './services/interceptors/token-interceptor/token.interceptor';
import { StepsModule } from 'primeng/steps';
import { EditorModule } from 'primeng/editor';
import { WorkCounterComponent } from './components/work-counter/work-counter.component';
import { ContactComponent } from './pages/contact/contact.component';
import { GetStartComponent } from './pages/generate resume/get-start/get-start.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { CircleProgressComponent } from './components/circle-progress/circle-progress.component';
import { CareerCoachComponent } from './pages/career-coach/career-coach.component';
import { PricingComponent } from './pages/career-coach/components/pricing/pricing.component';
import { DialogModule } from 'primeng/dialog';
import { CertificatesComponent } from './pages/career-coach/components/certificates/certificates.component';
import { ContentDialogComponent } from './components/content-dialog/content-dialog.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ResmeTargetComponent } from './pages/generate resume/generate-cv-steps/component/resme-target/resme-target.component';
import { GenerateCVStepsComponent } from './pages/generate resume/generate-cv-steps/generate-cv-steps.component';
import { CvTempletesComponent } from './pages/generate resume/generate-cv-steps/component/cv-templetes/cv-templetes.component';
import { EducationComponent } from './pages/generate resume/generate-cv-steps/component/education/education.component';
import { PersonalDataComponent } from './pages/generate resume/generate-cv-steps/component/personal-data/personal-data.component';
import { SelectResumeComponent } from './pages/generate resume/generate-cv-steps/component/select-resume/select-resume.component';
import { SkillsComponent } from './pages/generate resume/generate-cv-steps/component/skills/skills.component';
import { WorkExperienceComponent } from './pages/generate resume/generate-cv-steps/component/work-experience/work-experience.component';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { TagModule } from 'primeng/tag';
import { GalleriaModule } from 'primeng/galleria';

import { PaymentComponent } from './pages/payment/payment.component';
import { ComingSoonComponent } from './pages/coming-soon/coming-soon.component';
import { ReviewResumeComponent } from './pages/generate resume/generate-cv-steps/component/review-resume/review-resume.component';
import { ArticalComponent } from './pages/artical/artical.component';
import { ArticalDetailsComponent } from './pages/artical/components/artical-details/artical-details.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { GenerateLinkedinProfileComponent } from './pages/generate-linkedin-profile/generate-linkedin-profile.component';
import {
  NgxGoogleAnalyticsModule,
  NgxGoogleAnalyticsRouterModule,
} from 'ngx-google-analytics';
import { analyticsID } from 'src/app/models/baseURL';
import { tagID } from 'src/app/models/baseURL';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { VirtualInterviewComponent } from './pages/virtual-interview/virtual-interview.component';
import { CreateCoverLetterComponent } from './pages/create-cover-letter/create-cover-letter.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    GetReadySectionComponent,
    HeaderComponent,
    FooterSectionComponent,
    HeroSectionComponent,
    AtsResumeSectionComponent,
    AutomateSectionComponent,
    HeroSectionComponent,
    JobSeekersSectionComponent,
    OptimizeLinkedinSectionComponent,
    ResumeBuilderSectionComponent,
    ServicesSectionComponent,
    ScanCvComponent,
    ScanLinkedinComponent,
    ScanLinkedinResultComponent,
    ScanResultComponent,
    ResumeBuilderSectionComponent,
    ResetPasswordComponent,
    ResumeBuilderStepsSectionComponent,
    CardComponent,
    GetStartComponent,
    ContactComponent,
    WorkCounterComponent,
    LoginComponent,
    ForgetPasswordComponent,
    OtpCodeComponent,
    ResetPasswordComponent,
    SignUpComponent,
    CircleProgressComponent,
    CareerCoachComponent,
    PricingComponent,
    CertificatesComponent,
    ContentDialogComponent,
    ResmeTargetComponent,
    GenerateCVStepsComponent,
    DialogComponent,
    CvTempletesComponent,

    SelectResumeComponent,
    PersonalDataComponent,
    WorkExperienceComponent,
    EducationComponent,
    SkillsComponent,
    PaymentComponent,
    ComingSoonComponent,
    ReviewResumeComponent,
    ArticalComponent,
    ArticalDetailsComponent,
    GenerateLinkedinProfileComponent,
    VirtualInterviewComponent,
    CreateCoverLetterComponent,
 
  ],
  imports: [
    BrowserAnimationsModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    StepsModule,
    DropdownModule,
    InputMaskModule,
    AccordionModule,
    EditorModule,
    SelectButtonModule,
    BrowserModule,
    TagModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    CommonModule,
    CarouselModule,
    MatDialogModule,
    GalleriaModule,
    AnimateOnScrollModule,
    NgCircleProgressModule.forRoot(),
    TranslateModule,
    DialogModule,
    OAuthModule.forRoot(),
    HttpClientModule,
    NgxGoogleAnalyticsModule.forRoot(analyticsID),
    NgxGoogleAnalyticsRouterModule.forRoot(),
    GoogleTagManagerModule.forRoot({
      id: tagID,
    }),

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
